import { Transition } from "@uirouter/react";
import { MenuNode, MenuRoute } from "../../components/menu";
import { VaultsDTO } from "../../store/vaults/models/dto";
import { VaultService } from "../../store/vaults/service";
import { LeafRole, Or } from "../../utils/and-or-tree";
import { OverlayRoutes } from "../overlay/routes";
import { ShellRouteNames } from "../shell/route-names";
import { AllVaults } from "./all";
import { NewVault } from "./new";
import { SingleVault } from "./single";

const names = {
  vaultList: `${ShellRouteNames.shell}.vaults`,
  newVault: `${OverlayRoutes.name}.vaults-new`,
  singleVault: `${ShellRouteNames.shell}.vaults-single`,
};

const states: MenuRoute[] = [
  {
    name: names.vaultList,
    component: AllVaults,
    url: "/vaults",
    data: {
      title: "my-vaults",
    },
  },
  {
    name: names.newVault,
    views: {
      $default: {
        component: NewVault,
      },
      title: {
        component: () => <>Add new Vault</>,
      },
    },
    url: "/new-vault",
    data: {
      title: "new-vault",
    },
  },
  {
    name: names.singleVault,
    component: SingleVault,
    url: "/vaults/:id",
    data: {
      title: "vault-detail",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: [
      {
        token: "id",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().id,
      },
      {
        token: "item",
        deps: ["id"],
        resolveFn: (id: string) =>
          VaultService.getSingleVault(id).catch((err) => err),
      },
    ],
    redirectTo: (trans: Transition) => {
      // getAsync tells the resolve to load
      let resolvePromise: Promise<
        VaultsDTO.Responses.GetSingleVault.T | Error
      > = trans.injector().getAsync("item");
      return resolvePromise.then((
        err // TODO: maybe redirect to 404
      ) => (err instanceof Error ? names.vaultList : undefined));
    },
  },
];

const sidebar: MenuNode.MenuNode = {
  icon: "vaultManagement",
  route: states[0],
  disabled: true,
  roles: new Or(new LeafRole("ROLE_MERCHANT")),
};

export const VaultsRoutes = {
  names,
  states,
  sidebar,
};
